<template>
  <Modal
    v-if="ra_related_data"
    :id="'cmp-royalty-royalty_accounts-delete_account_modal'"
    class="cmp-royalty-royalty_accounts-delete_account_modal"
    @cancelled="onCancel"
  >
    <template slot="header">Attention</template>

    <template slot="body">
      <div class="body-container">
        <span>This royalty account has </span>

        <div class="count-content">
          <span>{{ ra_related_data.contract_count }} Contracts </span>
          <span>{{ ra_related_data.balance_count }} Balances </span>
          <span>{{ ra_related_data.royalty_period_count }} Statements </span>
        </div>
        <span></span>
        <span> Do you really want to delete this Royalty Account?</span>
      </div>
    </template>

    <template slot="options">
      <button style="margin-right: 3px;" class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Delete</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import * as ActionTypes from "../../store/types";

export default {
  components: {
    Modal,
    InputField,
  },
  props: ["selectedAccountDetails"],
  data() {
    return { ra_related_data: null };
  },
  mixins: [],
  mounted() {
    this.checkingOnDeleteRoyaltyAccount();
  },
  computed: {
    royalty_account_id: function () {
      return this.$route.query.royalty_account_id;
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    checkingOnDeleteRoyaltyAccount: async function () {
      const res = await AccountsService.checkingOnDeleteRoyaltyAccount(
        this.royalty_account_id
      );
      console.log("res.data", res.data);
      this.ra_related_data = {
        ...res.data.ra_related_data,
      };
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onOkClick: async function () {
      this[ActionTypes.AccountsList.DELETE.SINGLE]({
        royalty_account_id: this.royalty_account_id,
      });

      this.onCancel();
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-delete_account_modal {
  .dt-modal--header {
    text-align: center;
  }
  .body-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      font-weight: 400;
    }
    .count-content {
      display: flex;
      flex-direction: column;
      padding: 20px;
    }
  }
}
</style>
